var BlsSettingsSwiperTestimonial = (function () {
    return {
        init: function () {
            this.BlsSettingsCarouselTestimonial();
        },
        BlsSettingsCarouselTestimonial: function () {
            document
                .querySelectorAll(".bls__testimonial-carousel[data-section-id]")
                .forEach((element) => {
                    this.BlsCarouselTestimonial(element);
                });
        },
        BlsCarouselTestimonial: function (e) {
            var autoplaying = e?.dataset.autoplay === "true";
            var loop = e?.dataset.loop === "true";
            var itemDesktop = e?.dataset.desktop ? e?.dataset.desktop : 4;
            var itemTablet = e?.dataset.tablet ? e?.dataset.tablet : 2;
            var itemMobile = e?.dataset.mobile ? e?.dataset.mobile : 1;
            var sectionId = e?.dataset.sectionId;
            var width = window.innerWidth;
            var showThumb = e?.dataset.thumb === "true";
            var spacing = e?.dataset.spacing ? e?.dataset.spacing : 0;
            var progressbar = e?.dataset.paginationProgressbar === "true";
            var isRTL = document.documentElement.getAttribute("dir") === "rtl";
            spacing = Number(spacing);
            if (width <= 767) {
                if (spacing >= 15) {
                    spacing = 15;
                }
            } else if (width <= 1199) {
                if (spacing >= 30) {
                    spacing = 30;
                }
            }

            var swiperEl = "#bls__testimonial-" + sectionId;
            var shell = e.closest(".bls__testimonial-carousel-shell");
            var prevEl = shell ? shell.querySelector(".swiper-button-prev") : null;
            var nextEl = shell ? shell.querySelector(".swiper-button-next") : null;
            var pagEl = e.querySelector(".swiper-pagination");

            var baseConfig = {
                slidesPerView: itemMobile,
                spaceBetween: spacing,
                speed: 480,
                roundLengths: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                rtl: isRTL,
                autoplay: autoplaying
                    ? {
                          delay: 5000,
                          disableOnInteraction: false,
                          pauseOnMouseEnter: true,
                      }
                    : false,
                loop: loop,
                breakpoints: {
                    768: {
                        slidesPerView: itemTablet,
                    },
                    1200: {
                        slidesPerView: itemDesktop,
                    },
                },
            };

            if (prevEl && nextEl) {
                baseConfig.navigation = {
                    nextEl: nextEl,
                    prevEl: prevEl,
                };
            }

            if (pagEl) {
                baseConfig.pagination = {
                    clickable: true,
                    el: pagEl,
                    type: progressbar ? "progressbar" : "bullets",
                };
            }

            if (showThumb) {
                new Swiper(swiperEl, Object.assign({}, baseConfig, {
                    watchSlidesVisibility: true,
                    thumbs: {
                        swiper: {
                            el: `.testimonial-thumb-${sectionId}`,
                            multipleActiveThumbs: true,
                            spaceBetween: 10,
                            slidesPerView: "auto",
                            freeMode: true,
                            centerInsufficientSlides: true,
                            watchSlidesProgress: true,
                        },
                    },
                }));
            } else {
                new Swiper(swiperEl, Object.assign({}, baseConfig, {
                    watchSlidesVisibility: true,
                }));
            }
        },
    };
})();
BlsSettingsSwiperTestimonial.init();
